<template>
  <div class="index">
    <div class="speakers columns is-multiline">
      <div class="speaker-wrapper column is-one-third" v-for="speaker in speakersObject">
        <Speaker :speaker="speaker" @speaker-saved="reloadSpeakers" />
      </div>
    </div>
    <div class="centered add-speaker">
        <a class="button is-info" @click="handleAddSpeaker">+ Добавить спикера</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Speaker from 'components/Events/WebinarSpeaker'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'Speakers',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['speakers']),
    speakersObject () {
      return deepcopy(this.speakers)
    }
  },
  created () {
    this.getSpeakers()
  },
  methods: {
    ...mapActions(['getSpeakers', 'addWebinarSpeaker']),
    handleAddSpeaker () {
      this.addWebinarSpeaker({ id: uuidv4(), name: '' })
    },
    async reloadSpeakers() {
      try {
        await this.getSpeakers();
      } catch (error) {
        console.error("Ошибка при загрузке спикеров:", error);
      }
    }
  },
  components: { Speaker }
}
</script>

<style scoped>
@import "../../global.css";
.add-speaker {
  margin: 20px 0 30px;
}
.speaker-wrapper {
  margin: 10px 0 0;
}
.speaker {
  background: #eee;
  padding: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// Speakers.vue?2e59d0dd